import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ImagePreviewService {
  isLightboxOpen: boolean = false;
  lightboxStartIndex: number = 0;
  lightboxImages: string[] = [];
  constructor() {}
  openLightbox(images: string[], index: number) {
    this.lightboxImages = images;
    this.lightboxStartIndex = index;
    this.isLightboxOpen = true;
  }

  closeLightbox() {
    this.isLightboxOpen = false;
  }
}
